<template>
  <Teleport to="body">
    <div v-if="store.visible" class="ni-overlay" @click.self="store.toggle()">
      <div class="ni-panel">
        <NatsInspectorToolbar />
        <NatsInspectorList />
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useNatsInspectorStore } from './inspector-store'
import NatsInspectorToolbar from './NatsInspectorToolbar.vue'
import NatsInspectorList from './NatsInspectorList.vue'

const store = useNatsInspectorStore()

const onKeydown = (e: KeyboardEvent) => {
  if (e.ctrlKey && e.code === 'KeyQ') {
    e.preventDefault()
    store.toggle()
  }
}

onMounted(() => window.addEventListener('keydown', onKeydown))
onUnmounted(() => window.removeEventListener('keydown', onKeydown))
</script>

<style scoped>
.ni-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ni-panel {
  width: 100%;
  max-width: 1200px;
  height: calc(100vh - 48px);
  margin: 24px;
  background: #1e1e1e;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: #e0e0e0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 13px;
}
</style>
